import { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import { itemAttributeModel } from "../../../models/items/attributes/attribute.model";
import attributeActions from "../../../store/actions/items/attributes/attribute.actions";

export const AddAttributePageComponent = ({ attributeActions }) => {
  const [attributeDetails, setAttributeDetails] = useState(itemAttributeModel); // Use default model
  const [errors, setErrors] = useState({});
  const [serverResponse, setServerResponse] = useState(null);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setAttributeDetails({ ...attributeDetails, [name]: value });
  };

  const handleAddAttribute = async (event) => {
    event.preventDefault(); // Prevent default form submission
    try {
      const response = await attributeActions.addAttribute(attributeDetails);
      setServerResponse(response);
      setErrors({});
      alert("Attribute added successfully!");
    } catch (error) {
      console.error("Error adding attribute:", error);
      setErrors(error?.errors || {});
    }
  };

  return (
    <div>
      <h2>Add New Attribute</h2>
      <form onSubmit={handleAddAttribute}>
        <div>
          <label>Attribute Name</label>
          <input type="text" name="name" value={attributeDetails.name} onChange={handleInputChange} placeholder="Enter attribute name" />
          {errors.name && <span className="error">{errors.name}</span>}
        </div>
        <div>
          <label>Description</label>
          <textarea name="description" value={attributeDetails.description} onChange={handleInputChange} placeholder="Enter attribute description"></textarea>
          {errors.description && <span className="error">{errors.description}</span>}
        </div>
        <button type="submit">Add Attribute</button>
      </form>
      {serverResponse && (
        <div>
          <h4>Server Response:</h4>
          <pre>{JSON.stringify(serverResponse, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    attributeActions: bindActionCreators(attributeActions, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(AddAttributePageComponent);
